import { VStack, Text, Box, Center, Icon } from '@chakra-ui/react'
import { FaSearchLocation } from 'react-icons/fa'
import CorrespondentCard from './CorrespondentCard'
import { UserAround } from '../../../../../api/api_hooks/user/useGetUsersAroundPoint'
import { useTranslation } from 'react-i18next'

interface SuggestedCorrespondentsProps {
  users: UserAround[]
  selectedUser: UserAround | null
  onSelectUser: (user: UserAround) => void
}

const SuggestedCorrespondents = ({
  users,
  selectedUser,
  onSelectUser,
}: SuggestedCorrespondentsProps) => {
  const { t } = useTranslation()

  return (
    <VStack spacing={3} w="full" align="stretch">
      {users?.map((user) => (
        <CorrespondentCard
          key={user.id}
          user={user}
          isSelected={selectedUser?.id === user.id}
          onSelect={onSelectUser}
        />
      ))}
      {users?.length === 0 && (
        <Center py={20} flexDirection="column">
          <Box
            p={5}
            bg="gray.100"
            borderRadius="full"
            mb={5}
          >
            <Icon as={FaSearchLocation} boxSize={12} color="gray.400" />
          </Box>
          <Text color="gray.700" fontSize="md" fontWeight="semibold" textAlign="center" mb={2}>
            {t('sharedDiagnostic.noExpertsFound') || 'Aucun expert trouvé'}
          </Text>
          <Text color="gray.500" fontSize="sm" textAlign="center" maxW="300px" lineHeight="1.7">
            {t('sharedDiagnostic.tryAnotherLocationDesc') ||
              'Essayez de chercher dans une autre zone ou élargissez le rayon de recherche'}
          </Text>
        </Center>
      )}
    </VStack>
  )
}

export default SuggestedCorrespondents
